import { Controller } from "@hotwired/stimulus"
import pickmeup from "pickmeup"

export default class extends Controller {
  static targets = [
    "datepicker", "form", "date", "loading", "mode", "room"
  ]

  static values = {
  }

  connect() {
    this.DAY = true;
    this.MONTH = false;

    this.dayView()

    this.datepickerTarget.addEventListener("pickmeup-change", e => {
      this.reload(e.detail.formatted_date)
    })

    document.addEventListener("turbo:submit-end", _e => {
      this.loadingTarget.classList.add("hidden")
    })

    this.modeTargets.forEach((mode) => {
      mode.addEventListener("change", e => {
        this.changeMode(e.target.value)
      })
    })

    this.roomTarget.addEventListener("change", e => {
      this.reload(pickmeup(this.datepickerTarget).get_date("Y-m-d"))
    })
  }

  changeMode(mode) {
    if (mode === "day") {
      this.roomTarget.classList.add("hidden")
      this.dayView()
    } else if (mode === "month") {
      this.roomTarget.classList.remove("hidden")
      this.monthView()
    }
  }

  dayView() {
    this.createPickmeup(this.DAY);
    this.reload(
      new Date().toISOString().slice(0, 10)
    )
  }

  monthView() {
    this.createPickmeup(this.MONTH);
    this.reload(
      new Date().toISOString().slice(0, 10)
    )
  }

  createPickmeup(day = true) {
    const pickmeupElement = this.datepickerTarget
    pickmeup(pickmeupElement).destroy();
    pickmeup(pickmeupElement, {
      flat: true,
      format: "Y-m-d",
      select_day: day,
    });
  }

  reload(dateOrg) {
    if (!Date.parse(dateOrg)) {
      return "";
    }

    this.loadingTarget.classList.remove("hidden")

    this.dateTarget.value = dateOrg;
    this.formTarget.requestSubmit();
  }
}
